import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const costsPlugin = createPlugin({
  id: 'costs',
  routes: {
    root: rootRouteRef,
  },
});

export const CostsPage = costsPlugin.provide(
  createRoutableExtension({
    name: 'CostsPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
